import { WelcomeRoute } from "./routerules/welcomeRoute";
import { ProfileRoute } from "./routerules/profileRoute";
import { DrinkFrequencyRoute } from "./routerules/drinkFrequencyRoute";
import { DaysOfWeekRoute } from "./routerules/daysOfWeekRoute";
import { DrinksPerWeekDayRoute } from "./routerules/drinksPerWeekdayRoute";
import { MonthlyDaysRoute } from "./routerules/monthlyDaysRoute";
import { AverageDayRoute } from "./routerules/averageDayRoute";
import { SingleOccasionRoute } from "./routerules/singleOccasionRoute";
export const routeAction = {
  ...WelcomeRoute,
  ...ProfileRoute,
  ...DrinkFrequencyRoute,
  ...DaysOfWeekRoute,
  ...DrinksPerWeekDayRoute,
  ...MonthlyDaysRoute,
  ...AverageDayRoute,
  ...SingleOccasionRoute
};
